import AboutEstimator from './AboutEstimator'
import Awards from './Awards'
import Banner from './Banner'
import Button from './Button'
import Cards from './Cards'
import Divider from './Divider'
import Documents from './Documents'
import Gallery from './Gallery'
import Image from './Image'
import Logo from './Logo'
import Mission from './Mission'
import Quote from './Quote'
import Services from './Services'
import SocialLinks from './SocialLinks'
import Spacer from './Spacer'
import Terms from './Terms'
import Testimonials from './Testimonials'
import Text from './Text'
import ThreeColumn from './ThreeColumn'
import TwoColumn from './TwoColumn'
import WorkOrder from './WorkOrder'
import partnerSections from './partners'

export default {
  // Sherwin-Williams partner content, reused from v1 (#21311)
  ...partnerSections,
  '2-column': TwoColumn,
  '3-column': ThreeColumn,
  'about-estimator': AboutEstimator,
  awards: Awards,
  banner: Banner,
  logo: Logo,
  button: Button,
  cards: Cards,
  divider: Divider,
  documents: Documents,
  image: Image,
  gallery: Gallery,
  mission: Mission,
  quote: Quote,
  services: Services,
  'social-links': SocialLinks,
  terms: Terms,
  testimonials: Testimonials,
  text: Text,
  spacer: Spacer,
  'work-order': WorkOrder
}

import AboutEstimatorSection from './AboutEstimator/AboutEstimatorSection'
import AwardsSection from './Awards/AwardsSection'
import BannerSection from './Banner/BannerSection'
import ButtonSection from './Button/ButtonSection'
import CardsSection from './Cards/CardsSection'
import DividerSection from './Divider/DividerSection'
import DocumentsSection from './Documents/DocumentsSection'
import GallerySection from './Gallery/GallerySection'
import ImageSection from './Image/ImageSection'
import LogoSection from './Logo/LogoSection'
import MissionSection from './Mission/MissionSection'
import QuoteSection from './Quote/QuoteSection'
import ServicesSection from './Services/ServicesSection'
import SocialLinksSection from './SocialLinks/SocialLinksSection'
import SpacerSection from './Spacer/SpacerSection'
import TermsSection from './Terms/TermsSection'
import TestimonialsSection from './Testimonials/TestimonialsSection'
import TextSection from './Text/TextSection'
import ThreeColumnSection from './ThreeColumn/ThreeColumnSection'
import TwoColumnSection from './TwoColumn/TwoColumnSection'
import WorkOrderSection from './WorkOrder/WorkOrderSection'

export {
  AboutEstimatorSection,
  AwardsSection,
  BannerSection,
  ButtonSection,
  CardsSection,
  DividerSection,
  DocumentsSection,
  GallerySection,
  ImageSection,
  LogoSection,
  MissionSection,
  QuoteSection,
  ServicesSection,
  SocialLinksSection,
  SpacerSection,
  TermsSection,
  TestimonialsSection,
  TextSection,
  ThreeColumnSection,
  TwoColumnSection,
  WorkOrderSection
}
